import { useState } from "react";
import Modal from "../Base/Modal";
import styled from "styled-components";
import theme from "../../theme/theme";
import CustomTextBox from "../CustomTextBox/CustomTextBox";
import { Select } from "../Base/Select/index";
import { emailRegex } from "../../Regex";

const Wrapper = styled.div`
  .header {
    display: flex;
    width: 600px;

    .text {
      font-weight: 700;
      font-size: 32px;
      color: #004576;
      width: 80%;
    }

    .cross {
      width: 20%;
      text-align: right;
      padding-top: 8px;
      font-size: 20px;
    }
  }

  .body {
    width: 100%;

    .inputBoxSection {
      margin-top: 5%;

      .textArea {
        width: 93%;
        border: 1px solid #004576;
        border-radius: 8px;
        padding: 20px 20px;
        resize: none;
      }
    }

    .buttonContainer {
      width: 100%;
      margin-top: 5%;
      display: flex;
      justify-content: end;

      .button {
        color: white;
        font-size: 15px;
        font-weight: 700;
        padding: 15px 30px;
        border: none;
        background: ${theme.colors.primaryStrong2X};
        border-radius: 4px;
        cursor: pointer;
      }
    }

    .errorMessage {
      font-size: 12px;
      color: red;
      display: block;
      text-align: right;
      margin-top: 5px;
    }
  }
`;

const InviteClientModal = ({
  isInviteClientModalShow,
  inviteClientModalOnClose,
  advisorList,
  inviteClient,
  inviteClientError,
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [advisor, setAdvisor] = useState("");
  const [instructions, setInstructions] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleCustomTextBoxOnBlur = (textBoxName, value) => {
    if (textBoxName === "firstName") {
      setFirstName(value);
    } else if (textBoxName === "lastName") {
      setLastName(value);
    } else if (textBoxName === "email") {
      setEmail(value);
    }
  };

  const handleAdvisorChange = (option) => {
    setAdvisor(option);
  };

  const handleInviteClient = () => {
    if (firstName && lastName && email && advisor && instructions) {
      setErrorMessage("");
      const payload = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        instructions: instructions,
        advisorId: advisor,
      };
      inviteClient(payload);
    } else {
      setErrorMessage("All the fields are mandatory");
    }
  };

  const handleInstructionOnChange = (event) => {
    setInstructions(event.target.value);
  };

  return (
    <Modal
      show={isInviteClientModalShow}
      onClose={inviteClientModalOnClose}
      isBackgroundWhite={true}
    >
      <Wrapper>
        <div className="header">
          <div className="text">Invite Client</div>
          <div className="cross">
            <span
              style={{ cursor: "pointer" }}
              onClick={inviteClientModalOnClose}
            >
              X
            </span>
          </div>
        </div>
        <div className="body">
          <div className="inputBoxSection">
            <CustomTextBox
              placeholder="First Name"
              errorMessage="Not a valid name"
              name="firstName"
              value={firstName}
              onBlur={handleCustomTextBoxOnBlur}
            />
          </div>
          <div className="inputBoxSection">
            <CustomTextBox
              placeholder="Last Name"
              errorMessage="Not a valid name"
              name="lastName"
              value={lastName}
              onBlur={handleCustomTextBoxOnBlur}
            />
          </div>
          <div className="inputBoxSection">
            <CustomTextBox
              placeholder="Email"
              errorMessage={"Enter a valid email"}
              name="email"
              regexCode={emailRegex}
              onBlur={handleCustomTextBoxOnBlur}
            />
          </div>
          <div className="inputBoxSection">
            <Select
              options={
                (advisorList?.length &&
                  advisorList?.map((state) => ({
                    label: `${state.advisorName}`,
                    value: `${state.advisorId}`,
                  }))) ||
                []
              }
              defaultValue={""}
              onChange={handleAdvisorChange}
              label="Choose Advisor"
              placeholder="Choose Advisor"
              key={1}
            />
          </div>
          <div className="inputBoxSection">
            <textarea
              className="textArea"
              rows="5"
              value={instructions}
              onChange={handleInstructionOnChange}
              name="description"
              placeholder="Type instructions here..."
            />
          </div>
          <div className="buttonContainer">
            <button className="button" onClick={handleInviteClient}>
              Invite
            </button>
          </div>
          <div className="errorMessage">
            {errorMessage || inviteClientError}
          </div>
        </div>
      </Wrapper>
    </Modal>
  );
};

export default InviteClientModal;
